import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 3.75a8.25 8.25 0 0 0-7.35 4.5H9a.75.75 0 1 1 0 1.5H3A.75.75 0 0 1 2.25 9V3.004a.75.75 0 0 1 1.5 0v3.798A9.74 9.74 0 0 1 12 2.25c5.014 0 9.206 3.786 9.746 8.668a.75.75 0 0 1-1.491.164C19.799 6.964 16.252 3.75 12 3.75M20.25 20.996a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75h-6a.75.75 0 0 0 0 1.5h4.35a8.25 8.25 0 0 1-7.35 4.5c-4.252 0-7.8-3.214-8.255-7.332a.75.75 0 0 0-1.49.164c.54 4.882 4.731 8.668 9.745 8.668a9.74 9.74 0 0 0 8.25-4.552z"
    }, null, -1)
  ])))
}
export default { render: render }